/**
 * ============================================
 * Sim Nation — Build-a-Kit Wizard
 * ============================================
 * File: assets/build-a-kit.js
 */

(function () {
  'use strict';

  /* ─── CONFIG ─── */
  const TOTAL_STEPS = 6;
  const CATEGORY_LABELS = [
    'Launch Monitor',
    'Projector',
    'Screen & Enclosure',
    'Hitting Net',
    'Hitting Mat',
    'PC & Software',
  ];

  /* ─── STATE ─── */
  let currentStep = 0;
  let selections = new Array(TOTAL_STEPS).fill(null);

  /* ════════════════════════════════════════════
     STEP NAVIGATION
     ════════════════════════════════════════════ */

  function goToStep(step) {
    if (step < 0 || step >= TOTAL_STEPS) return;

    const tabs = document.querySelectorAll('.bak-step-tab');
    tabs[currentStep].classList.remove('active');
    tabs[step].classList.add('active');

    const contents = document.querySelectorAll('.bak-step-content');
    contents[currentStep].classList.remove('active');
    contents[step].classList.add('active');

    currentStep = step;

    const header = document.querySelector('.bak-page-header');
    if (header) {
      const y = header.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  function nextStep() {
    if (currentStep < TOTAL_STEPS - 1) goToStep(currentStep + 1);
  }

  function prevStep() {
    if (currentStep > 0) goToStep(currentStep - 1);
  }

  function skipStep() {
    selections[currentStep] = null;

    const tabs = document.querySelectorAll('.bak-step-tab');
    tabs[currentStep].classList.remove('completed');

    const content = document.querySelectorAll('.bak-step-content')[currentStep];
    content.querySelectorAll('.bak-option-card').forEach(function (c) {
      c.classList.remove('selected');
    });

    var nextBtn = document.getElementById('bakNextBtn' + currentStep);
    if (nextBtn) nextBtn.disabled = true;

    var stickyBtn = document.getElementById('bakStickyBtn' + currentStep);
    if (stickyBtn) stickyBtn.disabled = true;

    var topBtn = document.getElementById('bakTopBtn' + currentStep);
    if (topBtn) topBtn.disabled = true;

    updateSidebar();

    if (currentStep < TOTAL_STEPS - 1) goToStep(currentStep + 1);
  }

  /* ════════════════════════════════════════════
     PRODUCT SELECTION
     ════════════════════════════════════════════ */

  function selectOption(step, el) {
    var grid = el.closest('.bak-options-grid');
    grid.querySelectorAll('.bak-option-card').forEach(function (c) {
      c.classList.remove('selected');
    });

    el.classList.add('selected');

    // For variant cards, read data attrs directly from the card
    // (updateVariant keeps them in sync whenever the dropdown changes)
    selections[step] = {
      name: el.dataset.name,
      price: parseInt(el.dataset.price, 10),
      brand: el.dataset.brand,
      variantId: el.dataset.variantId,
      imageUrl: el.dataset.image || '',
      el: el,
    };

    var nextBtn = document.getElementById('bakNextBtn' + step);
    if (nextBtn) nextBtn.disabled = false;

    var stickyBtn = document.getElementById('bakStickyBtn' + step);
    if (stickyBtn) stickyBtn.disabled = false;

    var topBtn = document.getElementById('bakTopBtn' + step);
    if (topBtn) topBtn.disabled = false;

    var tabs = document.querySelectorAll('.bak-step-tab');
    tabs[step].classList.add('completed');

    updateSidebar();
  }

  /* ════════════════════════════════════════════
     VARIANT SELECTION
     Called when a size dropdown changes on a variant card.
     Updates the card's data attributes and refreshes price display,
     then re-fires selectOption if this card is already selected.
     ════════════════════════════════════════════ */

  function updateVariant(selectEl, step) {
    var card = selectEl.closest('.bak-option-card');
    var selected = selectEl.options[selectEl.selectedIndex];

    var newVariantId = selected.value;
    var newPrice = selected.dataset.price;
    var newName = selected.dataset.name;

    // Update card data attributes so selectOption always reads current values
    card.dataset.variantId = newVariantId;
    card.dataset.price = newPrice;
    card.dataset.name = newName;

    // Update the visible price on the card
    var productId = selectEl.dataset.productId;
    var priceEl = document.getElementById('bak-price-' + productId);
    if (priceEl) {
      priceEl.textContent = formatMoney(parseInt(newPrice, 10));
    }

    // If this card is already the active selection for this step,
    // update the stored selection and sidebar immediately
    if (selections[step] && selections[step].el === card) {
      selections[step].variantId = newVariantId;
      selections[step].price = parseInt(newPrice, 10);
      selections[step].name = newName;
      updateSidebar();
    }
  }

  /* ════════════════════════════════════════════
     SIDEBAR + MOBILE TOTAL BAR
     ════════════════════════════════════════════ */

  function updateSidebar() {
    var container = document.getElementById('bakSidebarItems');
    var emptyState = document.getElementById('bakEmptyState');
    var count = 0;
    var total = 0;

    for (var i = 0; i < TOTAL_STEPS; i++) {
      var slot = document.getElementById('bakSlot' + i);
      var existingItem = document.getElementById('bakItem' + i);

      if (selections[i]) {
        count++;
        total += selections[i].price;

        if (slot) slot.style.display = 'none';

        if (existingItem) {
          existingItem.querySelector('.bak-kit-name').textContent = selections[i].name;
          existingItem.querySelector('.bak-kit-price').textContent = formatMoney(selections[i].price);
          var img = existingItem.querySelector('.bak-kit-item-img img');
          if (img && selections[i].imageUrl) img.src = selections[i].imageUrl;
        } else {
          var item = document.createElement('div');
          item.className = 'bak-kit-item';
          item.id = 'bakItem' + i;
          item.innerHTML =
            '<div class="bak-kit-item-img">' +
              (selections[i].imageUrl
                ? '<img src="' + selections[i].imageUrl + '" alt="" width="52" height="52">'
                : '<span>IMG</span>') +
            '</div>' +
            '<div class="bak-kit-item-info">' +
              '<div class="bak-kit-category">' + CATEGORY_LABELS[i].toUpperCase() + '</div>' +
              '<div class="bak-kit-name">' + escapeHtml(selections[i].name) + '</div>' +
              '<div class="bak-kit-price">' + formatMoney(selections[i].price) + '</div>' +
            '</div>' +
            '<div class="bak-kit-item-actions">' +
              '<button class="bak-kit-item-btn" onclick="SimKit.swapItem(' + i + ')">Swap</button>' +
              '<button class="bak-kit-item-btn bak-remove" onclick="SimKit.removeItem(' + i + ')">Remove</button>' +
            '</div>';

          if (slot && container) {
            container.insertBefore(item, slot);
          } else if (container) {
            container.appendChild(item);
          }
        }
      } else {
        if (slot) slot.style.display = 'flex';
        if (existingItem) existingItem.remove();
      }
    }

    // ── Desktop sidebar ──
    if (emptyState) emptyState.style.display = count === 0 ? 'block' : 'none';

    var totalItemsEl = document.getElementById('bakTotalItems');
    if (totalItemsEl) totalItemsEl.textContent = count;

    var totalPriceEl = document.getElementById('bakTotalPrice');
    if (totalPriceEl) totalPriceEl.textContent = formatMoney(total);

    var itemCountEl = document.getElementById('bakItemCount');
    if (itemCountEl) itemCountEl.textContent = count + ' of ' + TOTAL_STEPS + ' selected';

    var progressFill = document.getElementById('bakProgressFill');
    if (progressFill) progressFill.style.width = ((count / TOTAL_STEPS) * 100) + '%';

    var addToCartBtn = document.getElementById('bakAddToCart');
    if (addToCartBtn) addToCartBtn.disabled = count === 0;

    var savingsMsg = document.getElementById('bakSavingsMsg');
    if (savingsMsg) savingsMsg.style.display = count >= 3 ? 'block' : 'none';

    // ── Mobile total bar ──
    var mobileTotalItems = document.getElementById('bakMobileTotalItems');
    if (mobileTotalItems) {
      mobileTotalItems.textContent = count + ' item' + (count !== 1 ? 's' : '');
    }

    var mobileTotalPrice = document.getElementById('bakMobileTotalPrice');
    if (mobileTotalPrice) {
      mobileTotalPrice.textContent = formatMoney(total);
    }
  }

  function swapItem(step) {
    goToStep(step);
  }

  function removeItem(step) {
    selections[step] = null;

    var contents = document.querySelectorAll('.bak-step-content');
    contents[step].querySelectorAll('.bak-option-card').forEach(function (c) {
      c.classList.remove('selected');
    });

    var tabs = document.querySelectorAll('.bak-step-tab');
    tabs[step].classList.remove('completed');

    var nextBtn = document.getElementById('bakNextBtn' + step);
    if (nextBtn) nextBtn.disabled = true;

    var stickyBtn = document.getElementById('bakStickyBtn' + step);
    if (stickyBtn) stickyBtn.disabled = true;

    var topBtn = document.getElementById('bakTopBtn' + step);
    if (topBtn) topBtn.disabled = true;

    var item = document.getElementById('bakItem' + step);
    if (item) item.remove();

    updateSidebar();
  }

  /* ════════════════════════════════════════════
     COMPARISON TABLE
     ════════════════════════════════════════════ */

  function openCompare(step) {
    var data = window.SimKitData;
    if (!data || !data.steps || !data.steps[step]) return;

    var stepData = data.steps[step];
    var products = stepData.products;

    document.getElementById('bakCompareTitle').textContent = 'Compare ' + stepData.label + 's';

    var specKeys = [];
    var seenKeys = {};
    products.forEach(function (p) {
      Object.keys(p.specs || {}).forEach(function (key) {
        if (!seenKeys[key]) { seenKeys[key] = true; specKeys.push(key); }
      });
    });

    var html = '<thead><tr><th></th>';
    products.forEach(function (p) { html += '<th>' + escapeHtml(p.title) + '</th>'; });
    html += '</tr></thead><tbody>';

    html += '<tr><td>Price</td>';
    products.forEach(function (p) { html += '<td>' + escapeHtml(p.price) + '</td>'; });
    html += '</tr>';

    specKeys.forEach(function (key) {
      html += '<tr><td>' + escapeHtml(key) + '</td>';
      products.forEach(function (p) {
        var val = (p.specs && p.specs[key]) || '—';
        var cls = val === '✓' ? ' class="bak-highlight"' : val === '—' ? ' class="bak-dim"' : '';
        html += '<td' + cls + '>' + escapeHtml(val) + '</td>';
      });
      html += '</tr>';
    });

    var hasBestFor = products.some(function (p) { return p.best_for; });
    if (hasBestFor) {
      html += '<tr><td>Best For</td>';
      products.forEach(function (p) { html += '<td>' + escapeHtml(p.best_for || '—') + '</td>'; });
      html += '</tr>';
    }

    html += '</tbody>';
    document.getElementById('bakCompareTable').innerHTML = html;
    document.getElementById('bakCompareOverlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCompare(e) {
    if (e.target.id === 'bakCompareOverlay') closeComparePanel();
  }

  function closeComparePanel() {
    document.getElementById('bakCompareOverlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeComparePanel();
  });

  /* ════════════════════════════════════════════
     SHOPIFY CART INTEGRATION
     ════════════════════════════════════════════ */

  async function addToCart() {
    var items = [];

    for (var i = 0; i < TOTAL_STEPS; i++) {
      if (selections[i] && selections[i].variantId) {
        if (selections[i].price === 0 && !selections[i].variantId) continue;
        items.push({
          id: parseInt(selections[i].variantId, 10),
          quantity: 1,
          properties: {
            _kit_bundle: 'true',
            _kit_category: CATEGORY_LABELS[i],
          },
        });
      }
    }

    if (items.length === 0) return;

    var btn = document.getElementById('bakAddToCart');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding to Cart...'; }

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });

      if (!response.ok) throw new Error('Cart API returned ' + response.status);

      await response.json();
      window.location.href = '/cart';

    } catch (error) {
      console.error('SimKit — Cart error:', error);
      if (btn) { btn.textContent = 'Error — Try Again'; btn.disabled = false; }
      setTimeout(function () { if (btn) btn.textContent = originalText; }, 3000);
    }
  }

  /* ════════════════════════════════════════════
     UTILITIES
     ════════════════════════════════════════════ */

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ════════════════════════════════════════════
     PUBLIC API
     ════════════════════════════════════════════ */

  window.SimKit = {
    goToStep: goToStep,
    nextStep: nextStep,
    prevStep: prevStep,
    skipStep: skipStep,
    selectOption: selectOption,
    updateVariant: updateVariant,
    swapItem: swapItem,
    removeItem: removeItem,
    openCompare: openCompare,
    closeCompare: closeCompare,
    closeComparePanel: closeComparePanel,
    addToCart: addToCart,
    getSelections: function () { return selections; },
    getTotal: function () {
      return selections.reduce(function (sum, s) { return sum + (s ? s.price : 0); }, 0);
    },
  };

})();